import { ShortURLInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/ShortURL/ShortURL.Service.ts
export class URLAPI {
  static async getShortURLByCode(code: string, incrementHits: boolean = true): Promise<ShortURLInterface | { expired: Date } | null> {
    return APIService.Server.get<ShortURLInterface>(`/short-url/code/${code}`, { incrementHits });
  }
  static async createShortURL(
    orgId: number,
    url: string,
    expiresAfterInMinutes?: number,
    userId?: number,
    sessionId?: number,
    locationId?: number
  ): Promise<ShortURLInterface> {
    return APIService.Server.post<ShortURLInterface>(`/short-url/org/${orgId}/create`, {
      url,
      expiresAfterInMinutes,
      userId: userId || undefined,
      sessionId: sessionId || undefined,
      locationId: locationId || undefined
    });
  }
}
